import React, { useEffect, useRef } from "react";
import { ModalUi } from "../../../../../ui/ModalUi";
import { ButtonUi } from "../../../../../ui/ButtonUi";
import { TipoButtonConstants } from "../../../../../../types/typesConstants";
import { FormUi } from "../../../../../ui/FormUi";
import { SearchComprobanteCompraForm } from "./SearchComprobanteCompraForm";
import { Form } from "antd";
const initialValues = (data = {}) => ({
  id: data?.id || null,
  proveedor: data?.proveedor || null,
  proveedor_nombre: data?.proveedor_nombre || null,
  change_proveedor: false,
  comprobantecompra: data?.comprobantecompra || null,
  detallecomprobantecompra: data?.detallecomprobantecompra || null,
});
const useResetFormOnCloseModal = ({ form, open, proveedor }) => {
  const prevOpenRef = useRef(null);
  useEffect(() => {
    prevOpenRef.current = open;
  }, [open]);
  const prevOpen = prevOpenRef.current;
  useEffect(() => {
    if (!open && prevOpen) {
      form.resetFields();
    } else {
      form.setFieldsValue({
        proveedor: proveedor?.id,
        proveedor_nombre: proveedor?.proveedor_nombre,
      });
    }
  }, [form, prevOpen, open]);
};
export const SearchComprobanteCompraModal = ({ open, onCancel, proveedor }) => {
  const [form] = Form.useForm();
  useResetFormOnCloseModal({ form, open, proveedor });
  const handleSave = (values) => {
    onCancel();
  };
  return (
    <ModalUi
      title="Comprobantes compra"
      centered
      maskClosable={false}
      destroyOnHidden
      open={open}
      onCancel={onCancel}
      width="50%"
      footer={[
        <ButtonUi
          key="back"
          typeUi={TipoButtonConstants.Cancelar}
          onClick={onCancel}
        />,
      ]}
    >
      <FormUi
        name="FormComprobanteCompra"
        form={form}
        layout="vertical"
        autoComplete="off"
        initialValues={initialValues()}
        handleSubmit={handleSave}
      >
        <SearchComprobanteCompraForm />
      </FormUi>
    </ModalUi>
  );
};
